export const addTheThe = (country: string): string => {
  if (country === "United States") {
    return "the United States";
  } else if (country === "United Kingdom") {
    return "the United Kingdom";
  } else if (country === "United Arab Emirates") {
    return "the United Arab Emirates";
  } else if (country === "United Republic of Tanzania") {
    return "the United Republic of Tanzania";
  } else if (country === "Czech Republic") {
    return "the Czech Republic";
  } else if (country === "Netherlands") {
    return "the Netherlands";
  } else if (country === "Philippines") {
    return "the Philippines";
  } else if (country === "Solomon Islands") {
    return "the Solomon Islands";
  } else if (country === "Azores") {
    return "the Azores";
  } else if (country === "Dominican Republic") {
    return "the Dominican Republic";
  }
  return country;
};
